export default function init_actions(IconsView, iconsViewCache) {

    IconsView.prototype.formatActionUrl = function (action, data, element) {
        const myself = this;
        let url = action.url;
        const dataType = (element && element.data('type')) || (data && data.type);

        // Résolution de l'URL API : options.api[type] si pas d'URL explicite
        if (!url && dataType && myself.options && myself.options.api && myself.options.api[dataType]) {
            url = myself.options.api[dataType];
        }

        if (!url) return '';
        url = String(url);

        let currentTab = this.containerView ? this.containerView.find('.iv__tabs > .iv__tabs__nav__wrap > .iv__tabs__nav .ui-tabs-active').data('id') : '';
        url = url.split('currentTab').join(currentTab || '');

        // Tab id
        let tabId = this.element.find('.tabs > .tabs__nav__wrap > ul .ui-tabs-active');
        tabId = tabId && tabId.length ? tabId.data('id') : '';
        url = url.split('tabId').join(tabId || '');

        // Macros targetId / targetSlug / targetLabel / targetType
        if (element) {
            url = url.split('targetId').join('dataId')
                     .split('targetSlug').join('dataSlug')
                     .split('targetLabel').join('dataLabel')
                     .split('targetType').join('dataType');
        } else {
            url = url.split('targetId').join('parentId')
                     .split('targetSlug').join('parentSlug')
                     .split('targetLabel').join('parentLabel')
                     .split('targetType').join('parentType');
        }

        // Remplacement des données de l'item ({id}, {dataId}, dataId, dataSlug, dataLabel, dataType)
        if (data && data.id !== undefined && data.id !== null) {
            url = url.split('dataId').join(data.id)
                     .split('{id}').join(data.id)
                     .split('{dataId}').join(data.id)
                     .split('dataSlug').join(data.slug || '')
                     .split('{slug}').join(data.slug || '')
                     .split('dataLabel').join(data.label || '')
                     .split('{label}').join(data.label || '')
                     .split('dataType').join(data.type || '')
                     .split('{type}').join(data.type || '');
            if (action.dataStr && data.data && data.data[action.dataStr] !== undefined) {
                url = url.split('dataStr').join(data.data[action.dataStr]);
            }
        }

        // Macros parent ({parentId}, parentId, parentSlug, parentLabel, parentType)
        const parentObj = (myself.dataNodeParent && myself.dataNodeParent.id) ? myself.dataNodeParent : null;
        if (parentObj) {
            url = url.split('parentId').join(parentObj.id)
                     .split('{parentId}').join(parentObj.id)
                     .split('parentSlug').join(parentObj.slug || '')
                     .split('parentLabel').join(parentObj.label || '')
                     .split('parentType').join(parentObj.type || '');
        } else if (myself.rootId) {
            url = url.split('parentId').join(myself.rootId)
                     .split('{parentId}').join(myself.rootId)
                     .split('parentType').join(myself.rootType || '');
        } else {
            // Nettoyage sécurisé des macros parent non résolues
            url = url.split('{parentId}').join('')
                     .split('{parentSlug}').join('')
                     .split('{parentLabel}').join('')
                     .split('{parentType}').join('');
        }

        // Api url macro
        if (url.indexOf('apiUrl') !== -1 && data && data.type && myself.options && myself.options.api) {
            url = url.split('apiUrl').join(myself.options.api[data.type] || '');
        }

        // Macros de filtres {{filterName}}
        if (myself.filters) {
            $.each(myself.filters, (filterName, filter) => {
                const val = (filter && filter.value !== undefined && filter.value !== null) ? filter.value : '';
                url = url.split('{{' + filterName + '}}').join(val);
            });
        }

        return url;
    };


IconsView.prototype.menuOption = function (name, icon, action) {
        const myself = this;
        // iconPath
        return {
            name,
            icon,
            callback(icon) {
                myself.action(action, icon);
            },
        };
    }


IconsView.prototype.iconTrigger = function (icon, trigger) {
        if ($(icon).hasClass('.iv__item')) {
            icon = $(icon).closest('.iv__item');
        }
        const grid = $(icon).closest('.iconGrid');
        const myself = icon.data('plugin') || this;
        let currentTrigger = (this.options && this.options.event) ? this.options.event[trigger] : undefined;

        console.log('[IconsView.iconTrigger]', {
            trigger,
            currentTrigger,
            options_event: this.options ? this.options.event : null,
            item_data: icon.data('data'),
            item_actions: icon.data('actions'),
            item_default: icon.data('default'),
            global_actions: myself.actions
        });

        if (icon.data('data') && icon.data('data').special == 'parent') currentTrigger = 'action';

        switch (currentTrigger) {
        // do the default action
        case 'action':
            if (icon.data('actions')) {
                let defaultName = icon.data('default');
                let currentAction = icon.data('actions')[defaultName];

                // 1. Chercher dans le catalogue global d'actions si non trouvé sur l'item
                if (!currentAction && defaultName) {
                    const actionCatalog = myself.actions || (myself.options && myself.options.actions);
                    if (actionCatalog && actionCatalog[defaultName]) {
                        currentAction = actionCatalog[defaultName];
                    }
                }

                // 2. Si defaultName est préfixé ou abrégé (ex: 'edit' vs 'image-edit' ou 'item-edit')
                if (!currentAction && defaultName) {
                    $.each(icon.data('actions'), (actionKey, act) => {
                        if (act && (act.name === defaultName || act.action === defaultName || String(actionKey).endsWith('-' + defaultName) || String(actionKey).startsWith(defaultName + '-'))) {
                            currentAction = act;
                            defaultName = actionKey;
                            return false;
                        }
                    });
                }

                // 3. Fallback : premier action cohérente (open, edit, browse)
                if (!currentAction) {
                    currentAction = icon.data('actions')['open'] || icon.data('actions')['edit'] || icon.data('actions')['browse'];
                }

                console.log('[IconsView.iconTrigger:action]', { defaultName, currentAction });

                if (currentAction) {
                    myself.action(currentAction, icon, defaultName);
                }
            } else {
                console.warn('[IconsView.iconTrigger:action] icon.data("actions") est vide ou inexistant sur l\'élément', icon);
            }
            break;

            // multiple select
        case 'select':
            if (icon.data('data').selectable !== false) { myself.iconSelect(icon); }

            myself.changeSelection(icon);
            break;

            // select interval
        case 'selectInt':
            if (!this.options.features.lockSelection) {
                var allIcons = grid.find('.iv__item');
                const selectedIcons = allIcons.filter('.iv__item--selected');
                const icon1 = icon;
                const icon2 = this.selectionLast || (selectedIcons.length > 0 ? selectedIcons.first() : null);
                if (icon2 && icon2.length && icon1[0] !== icon2[0]) {
                    this.selection = [];
                    allIcons.removeClass('iv__item--selected');
                    let started = false;
                    $(allIcons).each(function () {
                        const isMatch = (icon1[0] == $(this)[0] || icon2[0] == $(this)[0]);
                        if (isMatch) {
                            myself.iconSelect(this, true);
                            started = !started;
                        } else if (started) {
                            myself.iconSelect(this, true);
                        }
                    });
                    myself.changeSelection();
                    break;
                } else {
                    // Fallback to select1 if no range can be established
                    this.selection = [];
                    allIcons.removeClass('iv__item--selected');
                    if (icon.data('data') && icon.data('data').selectable !== false) {
                        myself.iconSelect(icon, true);
                    }
                    myself.changeSelection(icon);
                    break;
                }
            }

            // single select
        case 'select1':
            if (!this.options.features.lockSelection) {
                this.selection = [];
                var allIcons = grid.find('.iv__item');
                if (allIcons.filter('.iv__item--selected').length <= 1) allIcons = allIcons.not(icon);
                allIcons.removeClass('iv__item--selected');
                if (icon.data('data').selectable !== false) { myself.iconSelect(icon, true); }
                myself.changeSelection(icon);
            }
            break;


            // context menu
        case 'menu':
            if (!icon.hasClass('iv__item--selected')) {
                grid.find('.iv__item--selected').removeClass('iv__item--selected');
                myself.selection = [];
                myself.iconSelect(icon, true);
                myself.changeSelection(icon);
            }
            myself.createMenu(icon.data('menu'), icon);
            // icon.contextMenu();
            break;


            // do the default action
        default:
            if (icon.data('actions')) {
                var currentAction = icon.data('actions')[currentTrigger];
                if (currentAction) {
                    myself.action(currentAction, icon);
                }
            }
            break;
        }
    };


IconsView.prototype.resize = function () {
        const myself = this;

        if (myself.activeViewInstance && typeof myself.activeViewInstance.resize === 'function') {
            try {
                myself.activeViewInstance.resize();
            } catch (e) {}
        }

        this.setIconSize();
    };


IconsView.prototype.action = function (action, element, actionName) {
        const myself = this;
        if (myself.lockActions) return false;

        // Support string actions called on instance directly: inst.action('refresh') or inst.action('remove', options)
        if (typeof action === 'string') {
            switch (action) {
            case 'refresh':
                this.refresh ? this.refresh() : this.render();
                return true;
            case 'reload':
                this.load();
                return true;
            case 'update':
                this.update ? this.update() : this.render();
                return true;
            case 'remove':
                this.remove(element);
                return true;
            case 'toggleCensor':
            case 'censor':
                return this.toggleCensor();
            default:
                break;
            }
        }

        if (action && (element && (element.data || element.length))) {
            if (action.confirm) {
                if (typeof Swal !== 'undefined' && Swal && typeof Swal.fire === 'function') {
                    Swal.fire({
                        title: action.confirm.title,
                        text: action.confirm.text,
                        icon: (action.confirm.item) ? null : 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Oui',
                        cancelButtonText: 'Non',
                    }).then((result) => {
                        if (result && (result.value || result.isConfirmed)) {
                            myself.actionExecute(action, element, actionName);
                            myself.element.trigger('iv:action', [action, element, actionName, myself]);
                            myself.element.trigger('iconsview:action', [action, element, actionName, myself]);
                        }
                    });
                } else if (confirm(action.confirm.text || action.confirm.title || 'Voulez-vous supprimer cet élément ?')) {
                    myself.actionExecute(action, element, actionName);
                    myself.element.trigger('iv:action', [action, element, actionName, myself]);
                    myself.element.trigger('iconsview:action', [action, element, actionName, myself]);
                }
            } else {
                myself.actionExecute(action, element, actionName);
                myself.element.trigger('iv:action', [action, element, actionName, myself]);
                myself.element.trigger('iconsview:action', [action, element, actionName, myself]);
            }

            return true;
        }
        return false;
    };


IconsView.prototype.actionExecute = function (action, element, actionName) {
        const myself = this;
        if (action) {
            // target data
            let grid;
            const dataId = {};
            let items = [];

            if (element) {
                if ($(element).hasClass('iconGrid')) {
                    grid = $(element);
                    element = grid.find('.iv__item--selected');
                    $.each(element, function (index, currentElement) {
                        if (actionName) {
                            const itemActions = $(this).data('actions');
                            if (!itemActions || !itemActions[actionName]) return;
                        }
                        const type = $(this).data('type');
                        if (!dataId[type]) dataId[type] = [];
                        dataId[type].push({
                            id: $(this).data('id'),
                        });
                        items.push({
                            id: $(this).data('id'),
                            data: $(this).data('data'),
                            el: $(this),
                        });
                    });
                } else {
                    grid = $(element).closest('.iconGrid');
                    dataId[element.data('type')] = [{
                        id: element.data('id'),
                    }];
                    items = [{
                        id: element.data('id'),
                        data: element.data('data'),
                        el: element,
                    }];
                }
                // var myself = grid.data('plugin');
                var data = element.data('data');

                // load from container data
                if (!data) {
                    data = myself.dataNodeParent;
                }
            }

            // data ID url
            let currentTab = this.containerView.find('.iv__tabs > .iv__tabs__nav__wrap > .iv__tabs__nav .ui-tabs-active').data('id');
            let { url } = action;
            // Résolution de l'URL API : options.api[type] (nouvelle structure normalisée)
            if (element && !url && myself.options && myself.options.api && myself.options.api[element.data('type')]) {
                url = myself.options.api[element.data('type')];
            }

            url = String(url);
            url = url.replace('currentTab', currentTab);

            // auto target
            if (element) {
                url = url.replace('targetId', 'dataId');
                url = url.replace('targetSlug', 'dataSlug');
                url = url.replace('targetLabel', 'dataLabel');
                url = url.replace('targetType', 'dataType');
            }
            else {
                url = url.replace('targetId', 'parentId');
                url = url.replace('targetSlug', 'parentSlug');
                url = url.replace('targetLabel', 'parentLabel');
                url = url.replace('targetType', 'parentType');
            }

            // data replacement
            if (url && data && data.id) {
                url = url.replace('dataId', data.id);
                url = url.replace('dataSlug', data.slug);
                url = url.replace('dataLabel', data.label);
                url = url.replace('dataType', data.type);
                if (action.dataStr) url = url.replace('dataStr', data.data[action.dataStr]);
            }
            let urlData = (action.data ? '?' + jsonToUrl(action.data) : '');
            urlData = urlData.replace('currentTab', currentTab);
            if (data && data.id) {
                urlData = urlData.replace('dataId', data.id);
                urlData = urlData.replace('dataSlug', data.slug);
                urlData = urlData.replace('dataLabel', data.label);
                urlData = urlData.replace('dataType', data.type);
            }

            // parent ID url
            if (url.indexOf('parentId') != -1) {
                // ID of the true parent
                if (myself.dataNodeParent && myself.dataNodeParent.id) { // Replace parent ID macro
                    url = url.replace('parentId', myself.dataNodeParent.id);
                    url = url.replace('parentSlug', myself.dataNodeParent.slug);
                    url = url.replace('parentLabel', myself.dataNodeParent.label);
                    url = url.replace('parentType', myself.dataNodeParent.type);

                    url = url.replace('dataId', myself.dataNodeParent.id);
                    url = url.replace('dataSlug', myself.dataNodeParent.slug);
                    url = url.replace('dataLabel', myself.dataNodeParent.label);
                    url = url.replace('dataType', myself.dataNodeParent.type);
                }
                // Main root ID
                else if (myself.rootId) {
                    url = url.replace('parentId', myself.rootId);
                    url = url.replace('parentType', myself.rootType);

                    url = url.replace('dataId', myself.rootId);
                    url = url.replace('dataType', myself.rootType);
                }
                // No ID wipe all after
                else { // remove all after parentID if it don't exist
                    url = url.substring(0, url.indexOf('parentId'));
                    url = url.substring(0, url.indexOf('parentSlug'));
                    url = url.substring(0, url.indexOf('parentLabel'));
                    url = url.substring(0, url.indexOf('parentType'));

                    url = url.substring(0, url.indexOf('dataId'));
                    url = url.substring(0, url.indexOf('dataSlug'));
                    url = url.substring(0, url.indexOf('dataLabel'));
                    url = url.substring(0, url.indexOf('dataType'));
                }
            }

            // Api url
            if (url.indexOf('apiUrl') != -1) {
                const apiType = (data && data.type) || (element && element.data && element.data('type')) || (typeof dataId === 'object' ? Object.keys(dataId)[0] : null);
                if (myself.options && myself.options.api && apiType && myself.options.api[apiType]) {
                    url = url.replace('apiUrl', myself.options.api[apiType]);
                }
            }

            // Tab id
            let tabId = this.element.find('.tabs > .tabs__nav__wrap > ul .ui-tabs-active');
            if (tabId) tabId = tabId.data('id');
            else tabId = null;
            url = url.replace('tabId', tabId);

            // prompt input
            if (url && url.includes('{{input1}}')) {
                url = url.replace(new RegExp('{{input1}}', 'g'), prompt());
            }

            // filter in URL
            $.each(myself.filters, (filterName, filter) => {
                url = url.replace('{{' + filterName + '}}', filter.value);
            });

            if (element) {
                var icon = element.closest('.iv__item');
            }

            switch (action.action) {
            case 'popup':
                if (action.replace) {
                    closeWindow(myself.element);
                }
                myself.isBusy = true;
                $.window({
                    id: 'itemWindow' + ((data) ? data.id : ''),
                    title: String((action.title) ? action.title : action.label).replace('%s', data.label),
                    url: url + urlData,
                    icon: (data && data.icon) ? data.icon : action.icon,
                    method: (left(action.url, 4) == 'http') ? 'iframe' : 'ajax',
                    maxWidth: -1, // the minimum width, if -1 means no checking
                    maxHeight: -1,		 // the minimum height, if -1 means no checking
                    showFooter: false,
                    maximizable: false,
                    closable: true,
                    showModal: true,
                    width: (action.width) ? action.width : 1000,
                    height: (action.height) ? action.height : 650,
                    checkBoundary: true,
                    withinBrowserWindow: false,
                    iconView: myself,
                    iconData: data,
                    formFill: (action.formFill) ? myself.filters : {},
                    onIframeEnd() {
                    },
                    onClose() {
                        if (!action.replace) {
                            this.iconView.quickLoad(this.iconData, this.returnData);
                            this.iconView.isBusy = false;
                        }
                    },
                });
                break;
            case 'newtab':
                var dataOut = [];
                for (var key in action.data) {
                    if (action.data.hasOwnProperty(key)) {
                        dataOut.push(key + '=' + encodeURIComponent(action.data[key]));
                    }
                }
                dataOut = dataOut.join('&');
                if (dataOut) dataOut = '?' + dataOut;

                window.open(url + dataOut, '_blank');
                break;
            case 'link':
                var dataOut = [];
                for (var key in action.data) {
                    if (action.data.hasOwnProperty(key)) {
                        dataOut.push(key + '=' + encodeURIComponent(action.data[key]));
                    }
                }
                dataOut = dataOut.join('&');
                if (dataOut) dataOut = '?' + dataOut;

                window.location.href = url + dataOut;
                break;
            case 'script':
                try {
                    if (typeof action.script === 'function') {
                        action.script.call(myself, data, element, myself);
                    } else if (typeof action.callback === 'function') {
                        action.callback.call(myself, data, element, myself);
                    } else if (typeof action.script === 'string') {
                        eval(action.script);
                    }
                } catch (scriptErr) {
                    console.error('[IconsView.actionExecute:script] Erreur lors de l\'exécution du script:', scriptErr, action);
                    if (myself.events && typeof myself.events.error === 'function') {
                        myself.events.error(scriptErr);
                    }
                }
                break;
            case 'ajax':
                var options = {
                    url,
                    type: (action.method || 'get'),
                    data: action.data,
                    dataType: 'json',
                    contentType: 'application/json; charset=utf-8',
                };
                if (action.success) options.success = action.success;
                if (action.complete) options.complete = action.complete;
                if (action.error) {
                    options.error = action.error;
                } else {
                    options.error = function (xhr, status, err) {
                        console.error('[IconsView.actionExecute:ajax] Erreur AJAX:', status, err, url);
                        if (myself.events && typeof myself.events.error === 'function') {
                            myself.events.error(status);
                        }
                    };
                }
                var request = $.ajax(options);
                break;
            case 'ajaxForm':
                /* if (typeof dataId == 'number') {
                        dataId = [{
                            id: dataId
                        }]
                    } */
                $.each(dataId, (dataType, data) => {
                    if (action.data) {
                        for (let i = 0; i < data.length; i++) {
                            mergeToObject(action.data, data[i]);
                        }
                    }
                    let reqUrl = url;
                    if (!action.url || reqUrl.indexOf('apiUrl') !== -1 || reqUrl === 'undefined' || !reqUrl) {
                        if (myself.options && myself.options.api && myself.options.api[dataType]) {
                            reqUrl = myself.options.api[dataType];
                        }
                    }
                    ajaxForm({
                        url: reqUrl,
                        method: action.method,
                        data,
                        plugin: myself,
                        success(data, form) {
                            this.plugin.quickLoad();
                        },
                    });
                });
                break;
            case 'update':
                myself.submitChange(data, action.data);
                break;
            case 'delete':
                myself.submitDelete(data);
                break;
            case 'browse':
                myself.setPath(data);
                myself.render(data.childs);
                break;
            case 'browseParent':
                myself.setPath(data.parent.parent);
                myself.render(data.parent.parent.childs);
                break;
            case 'mediaPreview':
                element.find('.iv__item__preview').click();
                break;
            case 'selectAll':
                grid.find('.iv__item').addClass('iv__item--selected');
                myself.changeSelection();
                break;
            case 'unselectAll':
                grid.find('.iv__item').removeClass('iv__item--selected');
                myself.changeSelection();
                break;
            case 'setView':
                myself.setView(action.view);
                break;
            case 'setModes':
            case 'modes':
                myself.setModes(action.modes || action.views || (action.data ? action.data.modes : null));
                break;
            case 'refresh':
                myself.render();
                break;
            case 'reload':
                myself.load();
                break;
            case 'sort':
                myself.sort(action.order, action.type);
                break;
            case 'add':
                myself.add(action.data);
                break;
            case 'remove':
                myself.remove(data);
                break;
            case 'select1':
                this.selection = [];
                var allIcons = grid.find('.iv__item');
                if (allIcons.filter('.iv__item--selected').length <= 1) allIcons = allIcons.not(icon);
                allIcons.removeClass('iv__item--selected');
                if (icon.data('data').selectable !== false) { myself.iconSelect(icon, true); }
                myself.changeSelection(icon);
                break;
            case 'multi':
                $.each(action.actions, function () {
                    element.data('plugin').actionExecute(this, element);
                });
                break;
            case 'toggleCensor':
            case 'censor':
                myself.toggleCensor();
                break;
            default:
                msg('info', 'The feature "' + action.action + '" is not implemented yet');
                break;
            }
            return true;
        }
        return false;
    };


IconsView.prototype.setView = function(view) {
        const myself = this;
        const allowedModes = myself.getAllowedModes();
        if (view == 'auto') {
            myself.viewLock = false;
            if (myself.template && myself.template.view && myself.template.view.default) myself.view = myself.template.view.default;
        } else if (view == 'next') {
            myself.viewLock = false;
            const modes = (allowedModes && allowedModes.length) ? allowedModes : ((myself.template && myself.template.view && myself.template.view.modes) || ['table', 'mosaic', 'list', 'icons', 'thumbnails', 'tree', 'summary', 'calendar']);
            let currentViewIndex = modes.indexOf(myself.view);
            currentViewIndex++;
            let currentView = modes[currentViewIndex];
            if (!currentView) currentView = modes[0];
            myself.view = currentView;
        } else {
            if (allowedModes && allowedModes.length) {
                const norm = (view === 'thumbs' ? 'thumbnails' : (view === 'grid' ? 'mosaic' : view));
                const isCalendarSub = (norm === 'calendar-week' || norm === 'calendar-day') && allowedModes.includes('calendar');
                if (!allowedModes.includes(norm) && !allowedModes.includes(view) && !isCalendarSub) {
                    return false;
                }
            }
            myself.viewLock = true;
            myself.view = view;
        }
        const viewKey = this.templateName + ':' + myself.view;
        this.fixedSize[viewKey] = null;
        this.fixedSize[this.templateName] = null;
        this.fixedView[this.templateName] = myself.view;
        myself.setPath(this.path, true);
        myself.loadPath(null, true);
        myself.render();
    };


IconsView.prototype.setModes = function (modes) {
        if (typeof modes === 'string') {
            try {
                const parsed = JSON.parse(modes);
                if (Array.isArray(parsed)) modes = parsed;
                else modes = modes.split(',').map(m => m.trim()).filter(Boolean);
            } catch (e) {
                modes = modes.split(',').map(m => m.trim()).filter(Boolean);
            }
        }
        this.modes = modes;
        if (this.template && this.template.view) {
            this.template.view.modes = modes;
        }
        this.buildGlobalMenu();
    };


IconsView.prototype.iconSelect = function (icon, status, force) {
        if (!this.options.features.lockSelection || force) {
            icon = $(icon);
            if (!status && status !== false) status = 'toggle';
            if (icon.data('data').selectable !== false) {
                if (status == 'toggle') icon.toggleClass('iv__item--selected');
                if (status == true) {
                    icon.addClass('iv__item--selected');
                }
                if (status == false) {
                    icon.removeClass('iv__item--selected');
                }

                if (icon.hasClass('iv__item--selected')) {
                    this.addSelectionFromIcon(icon);
                } else {
                    this.removeSelectionFromIcon(icon);
                }
            }
        }
    };


}
